// extracted by mini-css-extract-plugin
export var container = "_qo-0";
export var dotAnimation = "_qo-2";
export var dotsLoading = "_qo-1";